import ProductReservationsAPI from '@/API/my-menu/product-reservations-api'

export default {
  namespaced: true,
  state: {
    fetched: false,
    noProductReservations: false,
  },

  getters: {
    noProductReservations: (state: any) => state.noProductReservations,
  },

  mutations: {
    SET_DATA(state: any, payload: any) {
      state.noProductReservations = payload.noOrders ?? payload.no_orders ?? false
      state.fetched = true
    },
    RESET_FETCH(state: any) {
      state.fetched = false
    },
  },

  actions: {
    async FETCH_DEPENDENCIES(context: any, force = false) {
      if (context.state.fetched && !force) {
        return
      }

      try {
        const branchId = context.rootGetters['branches/currentBranchId']
        const data = await ProductReservationsAPI.getSettings(branchId)
        context.commit('SET_DATA', data)
      } catch (err) {
        console.log(err)
        throw err
      }
    },
    RESET_FETCH(context: any) {
      context.commit('RESET_FETCH')
    },
  },
}
